import type { ErrorModalProps } from './interfaces';
import ModalPortal from '@/components/ModalPortal/ModalPortal';
import { BoxWidth } from '../Box/consts';
import { HeadlineLevel } from '../Headline/consts';
import Headline from '../Headline/Headline';
import ModalCloseIcon from '../Modal/ModalCloseIcon/ModalCloseIcon';
import ModalContent from '../Modal/ModalContent';
import Stack from '../Stack/Stack';

const ErrorModal = ({
  id,
  handleClose,
  isVisible,
  headline,
  subText,
  button,
}: ErrorModalProps) => {
  return (
    <ModalPortal
      id={`error-modal-${id ?? headline}`}
      onClose={handleClose}
      show={isVisible}
      variant="shade"
      disableCloseIcon={true}
    >
      <ModalContent width={BoxWidth.SMedium}>
        <ModalCloseIcon onClick={handleClose} />
        <Stack gap={2} alignItems="center">
          <Headline subText={subText} level={HeadlineLevel.Three}>
            {headline}
          </Headline>
          {button}
        </Stack>
      </ModalContent>
    </ModalPortal>
  );
};

export default ErrorModal;
